import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { Item, JobApiResponse } from '../../interfaces/api-response';
import { ContentJobComponent } from '../content-job/content-job.component';

@Component({
  selector: 'career-content-detail',
  standalone: true,
  imports: [HttpClientModule, CommonModule, ContentJobComponent],
  templateUrl: './content-detail.component.html',
  styleUrl: './content-detail.component.scss',
})
export class ContentDetailComponent implements OnInit {
  @Input({ required: true }) jobId!: string;

  job: Item | null = null;
  loading = true;

  constructor(private http: HttpClient) {}

  ngOnInit() {
    this.loadJob(this.jobId);
  }

  private loadJob(id: string): void {
    this.loading = true;

    this.http.get<JobApiResponse>(`/api/jobs/${id}`).subscribe({
      next: (response) => {
        this.job = this.normalizePayload(response.payload);
        this.loading = false;
      },
      error: () => {
        this.job = null;
        this.loading = false;
      },
    });
  }

  private normalizePayload(payload: Item | Item[]): Item | null {
    if (Array.isArray(payload)) {
      return payload[0] ?? null;
    }

    return payload ?? null;
  }
}
